import { OpenDialogWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('OpenDialog')
export class OpenDialogNodeSchemaProvider extends SchemaProvider<OpenDialogWorkflowNode> {}
